import { Toaster } from "react-hot-toast"
import Layout from "../../shared/Layout"
import { GetLoginDetailById, GetProductOrderByLoginId} from "../../../_services";
import { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { Modal } from 'antd';
// import CustomerOrderDetail from "./CustomerOrderDetail";
import toast from "react-hot-toast";

const CustomerDetail = () => {
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [productOrderByLoginIdData, setProductOrderByLoginIdData] = useState([]);
    const [loginDetailById, setLoginDetailById] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [productOrderDetails, setProductOrderDetails] = useState([]);

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const fetchProductOrderByLoginId = async () => {
        try {
            const data = await GetProductOrderByLoginId();
            if (data.isSuccess === 200) {
                setProductOrderByLoginIdData(data.data);
            }
        } catch (error) {
            toast.error( error);
        }finally{
            setLoading(false);
        }
    };

    const fetchLoginDetailById = async () => {
        try {
            const data = await GetLoginDetailById();
            if (data.isSuccess === 200) {
                setLoginDetailById(data.data[0]);
            }
        } catch (error) {
            toast.error("Error fetching menu data:", error);
        }
    };

    useEffect(() => {
        fetchProductOrderByLoginId();
        fetchLoginDetailById();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = productOrderByLoginIdData.filter(item => {
                const searchValue = searchTerm.toLowerCase();
                return (
                    item.orderId.toString().toLowerCase().includes(searchValue) ||
                    item.totalAmount.toString().toLowerCase().includes(searchValue) 
                );
            });
            setFilteredData(filtered);
        } else {
            setFilteredData(productOrderByLoginIdData);
        }
    }, [searchTerm, productOrderByLoginIdData]);

    // const onCustomerOrderDetail = async (item) => {
    //     try {
    //         setIsModalOpen(true);

    //         const productOrderDetails = await GetProductOrderByOrderId(item.orderId);

    //         setProductOrderDetails(productOrderDetails.data[0]);
    //     } catch (error) {
    //         setProductOrderDetails([]);
    //     }
    // };


    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '70px'
        },
        {
            name: 'Order ID',
            selector: row => row.orderId,
            sortable: true
        },
        {
            name: 'Total',
            selector: row => row.totalAmount,
            sortable: true
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    {/* <span className="edit_icon_wepper" title='view' onClick={() => onCustomerOrderDetail(row)}>
                        <i className="fas fa-eye"></i>
                    </span> */}
                    <span className="delete_icon_weepr" title='invoice'>
                        <i className="fa fa-download" style={{ fontSize: "16px" }}></i>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];

    return (
        <Layout>
            <div className="px-4">
                <div className="admin-page mt-4 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex align-items-center" style={{ gap: "10px" }}>
                        <img src="../images/usermulti.png" style={{ width: '25px' }} alt=""/>
                        <h4 className="mb-0">Customer Details</h4>
                    </div>
                    <div className="d-md-flex align-items-center" style={{ gap: "20px" }}>
                        <div className="search-container col-md-12">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div className="d-sm-flex align-items-center pt-3" style={{ gap: '20px' }}>
                    <h5 className="mb-0">
                        <span>Customer ID </span>
                        <span>#{loginDetailById?.loginId}</span>
                    </h5>
                    <div>
                        <span style={{ fontSize: '14px', color: '#000000a8' }}> Joined At : </span>
                        <span style={{ fontSize: '14px', color: '#000000a8' }}>
                            {loginDetailById?.createdDate &&
                                new Date(loginDetailById.createdDate).toLocaleString('en-GB', {
                                    day: 'numeric',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                    hour12: false,
                                })}
                        </span>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="datatable col-8">
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </div>
                    <div className="col-4">
                        <div className="customer_wrapper">
                            <h6 className="d-flex align-items-center" style={{ gap: '10px' }}>
                                <img src="./images/seller-information.png" alt=""/>
                                Customer
                            </h6>
                            <div className="d-flex pt-3" style={{ gap: '10px' }} >
                                <span>
                                    <img src="./images/image-place-holder.png" alt="" style={{ width: '80px' }} />
                                </span>
                                <div className="customer_detail_wrapper" >
                                    <h6 className="mb-0">{loginDetailById?.name}</h6>
                                    <span>{productOrderByLoginIdData?.length} Orders</span>
                                    <p>{loginDetailById?.emailId}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Toaster position="top-right" />
            </div>

            <Modal
                title="Order Details"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={800}
                className="customer_order_detail_popup"
            >
                {/* <CustomerOrderDetail
                    order_id={productOrderDetails.order_id}
                    order_date={productOrderDetails.order_date}
                    order_items={productOrderDetails.order_items}
                    sub_total = {productOrderDetails?.sub_total}
                    billing_customer_name={productOrderDetails?.billing_customer_name}
                    billing_phone={productOrderDetails?.billing_phone}
                    billing_city={productOrderDetails?.billing_city}
                    billing_pincode={productOrderDetails?.billing_pincode}
                    loading={loading}
                /> */}
            </Modal>
        </Layout>
    )
}
export default CustomerDetail